import {Component, input, InputSignal, output} from '@angular/core';
import {NgFor} from '@angular/common';
import {AlertComponent, Notification} from '@uofu-uss/angular-util';

@Component({
  selector: 'app-uss-alerts',
  standalone: true,
  imports: [
    AlertComponent,
    NgFor,
  ],
  template: `
    <uss-alert *ngFor="let alert of alerts(); first as isFirst"
               [styling]="'d-flex align-items-center alert align-items-stretch py-3 px-0 mb-0 rounded-0 border-top-0 border-start-0 border-bottom-1 border-end-0'"
               [fullWidth]="true"
               [model]="alert.model"
               [type]="alert.type"
               [requestFocus]="alert.changeFocus ? isFirst : false"
               [closeable]="true"
               (closed)="onClosed(alert)"
               class="hidden-print">
    </uss-alert>
  `
})
export class AlertsComponent {

  readonly alerts: InputSignal<ReadonlyArray<Notification>> = input([] as ReadonlyArray<Notification>);
  readonly remove = output<Notification>();

  onClosed(notification: Notification) {
    this.remove.emit(notification);
  }

}
